import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchEventById } from '../services/strapiService'; // ← Usa il servizio Strapi
import styled from 'styled-components';

// Rimuovi tutti i MOCK_EVENTS - non servono più

const DirectionsButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #4285F4;
  color: white;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 15px;
  font-weight: 500;
  transition: background 0.3s;
  
  &:hover {
    background: #3367D6;
  }
`;

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const BackButton = styled.button`
  background-color: #f39c12;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  
  &:hover {
    background-color: #e67e22;
  }
`;

const EventHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
  }
  
  .date-location {
    display: flex;
    color: #666;
    gap: 20px;
    margin-bottom: 10px;
  }
  
  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }
  
  .tag {
    background-color: #f1f1f1;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 14px;
  }
`;

const EventContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const EventDescription = styled.div`
  line-height: 1.6;
  
  h2 {
    margin-bottom: 15px;
    color: #333;
  }
  
  .images-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 20px;
    
    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
`;

const EventSidebar = styled.div`
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  
  h3 {
    margin-top: 0;
    margin-bottom: 15px;
    color: #333;
  }
  
  .info-item {
    margin-bottom: 15px;
    
    strong {
      display: block;
      margin-bottom: 5px;
    }
    
    a {
      color: #f39c12;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const EventDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Caricamento evento con ID:', id);
        
        // ✅ USA IL SERVIZIO STRAPI
        const eventData = await fetchEventById(id);
        
        if (eventData) {
          console.log('Evento caricato:', eventData);
          setEvent(eventData);
        } else {
          setError('Evento non trovato');
        }
        
      } catch (err) {
        console.error('Errore nel caricamento dei dettagli evento:', err);
        setError('Si è verificato un errore nel caricamento dei dettagli dell\'evento. Riprova più tardi.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEventDetails();
    } else {
      setError('ID evento mancante');
      setLoading(false);
    }
  }, [id]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        height: '100vh'
      }}>
        Caricamento dettagli evento in corso...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center',
        height: '100vh',
        padding: '20px'
      }}>
        <h2>Errore</h2>
        <p>{error}</p>
        <BackButton onClick={() => navigate(-1)}>
          ← Torna indietro
        </BackButton>
      </div>
    );
  }

  if (!event) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center',
        height: '100vh'
      }}>
        <h2>Evento non trovato</h2>
        <BackButton onClick={() => navigate(-1)}>
          ← Torna indietro
        </BackButton>
      </div>
    );
  }

  // Funzione per formattare la data
  const formatDate = (dateString) => {
    if (!dateString) return 'Data non disponibile';
    try {
      return new Date(dateString).toLocaleDateString('it-IT', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch (error) {
      return 'Data non valida';
    }
  };

  return (
    <PageContainer>
      <BackButton onClick={() => navigate(-1)}>
        ← Torna indietro
      </BackButton>
      
      <EventHeader>
        <h1>{event.title}</h1>
        <div className="date-location">
          <span>📅 {formatDate(event.startDate || event.date)}</span>
          <span>📍 {event.location}</span>
        </div>
        {event.categories && event.categories.length > 0 && (
          <div className="tags">
            {event.categories.map(category => (
              <span key={category.id} className="tag">{category.name}</span>
            ))}
          </div>
        )}
      </EventHeader>
      
      <EventContent>
        <EventDescription>
          <h2>Descrizione</h2>
          <div>{event.description || 'Nessuna descrizione disponibile'}</div>
          
          {/* Galleria immagini da Strapi */}
          {event.image && event.image.length > 0 && (
            <div className="event-gallery">
              <h2>Galleria</h2>
              <div className="images-grid">
                {event.image.map((image, index) => (
                  <img 
                    key={index} 
                    src={image.url} 
                    alt={`${event.title} - immagine ${index + 1}`} 
                  />
                ))}
              </div>
            </div>
          )}
        </EventDescription>
        
        <EventSidebar>
          <h3>Informazioni</h3>
          
          {/* Data e ora */}
          <div className="info-item">
            <strong>Data:</strong> 
            {formatDate(event.startDate || event.date)}
          </div>

          {event.endDate && (
            <div className="info-item">
              <strong>Data fine:</strong> 
              {formatDate(event.endDate)}
            </div>
          )}
          
          {/* Prezzo */}
          {event.ticketPrice !== null && event.ticketPrice !== undefined && (
            <div className="info-item">
              <strong>Prezzo:</strong> 
              {event.ticketPrice === 0 ? 'Gratuito' : `€${event.ticketPrice}`}
            </div>
          )}
          
          {/* Sito web */}
          {event.url && (
            <div className="info-item">
              <strong>Sito web:</strong>
              <a href={event.url} target="_blank" rel="noopener noreferrer">
                {event.url.replace(/^https?:\/\//, '')}
              </a>
            </div>
          )}
          
          {/* Email */}
          {event.email && (
            <div className="info-item">
              <strong>Email:</strong> 
              <a href={`mailto:${event.email}`}>{event.email}</a>
            </div>
          )}

          {/* Telefono */}
          {event.phone && (
            <div className="info-item">
              <strong>Telefono:</strong> 
              <a href={`tel:${event.phone}`}>{event.phone}</a>
            </div>
          )}

          {/* Organizzatore */}
          {event.alternativeOrganizer && (
            <div className="info-item">
              <strong>Organizzatore:</strong> 
              {event.alternativeOrganizer}
            </div>
          )}
          
          {/* Posizione */}
          <div className="info-item">
            <strong>Posizione:</strong>
            <div>{event.location}</div>
            {event.address && event.address !== event.location && (
              <div>{event.address}</div>
            )}
          </div>
          
          {/* Indicazioni stradali */}
          {event.latitude && event.longitude && (
            <div className="info-item">
              <DirectionsButton 
                href={`https://www.google.com/maps/dir/?api=1&destination=${event.latitude},${event.longitude}&travelmode=driving`} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <span>📍</span> Indicazioni stradali
              </DirectionsButton>
            </div>
          )}

          {/* Stato evento */}
          {event.isExpired && (
            <div className="info-item">
              <strong style={{ color: '#e74c3c' }}>⚠️ Evento terminato</strong>
            </div>
          )}

          {/* Mini mappa placeholder */}
          <div style={{ 
            marginTop: '20px', 
            height: '200px', 
            background: '#e0e0e0', 
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#666'
          }}>
            {event.latitude && event.longitude ? (
              <div style={{ textAlign: 'center' }}>
                <div>📍 Posizione evento</div>
                <small>Lat: {event.latitude.toFixed(4)}, Lng: {event.longitude.toFixed(4)}</small>
              </div>
            ) : (
              'Posizione non disponibile'
            )}
          </div>
        </EventSidebar>
      </EventContent>
    </PageContainer>
  );
};

export default EventDetailPage;
